import APP from 'src/main.js'
import Event from './Event.js'

class TradeCancel extends Event {
    get trade(){
        let value = (this.constructor.employeeStore.event_relations.find(rel => (rel.child_id===this.id)&&(rel.parent_type==='Trade'))||{}).parent_id
        if(value){
            return this.constructor.employeeStore.events.find(ev => (ev.id===value)&&ev.id)
        } else {
            return null
        }
    }
    get trade_expected(){
        let value = (this.constructor.employeeStore.event_relations.find(rel => (rel.child_id=== this.id)&&(rel.parent_type==='TradeExpected'))||{}).parent_id
        if(value){
            return this.constructor.employeeStore.events.find(ev => (ev.id===value)&&ev.id)
        } else {
            return null
        }
    }
}
export default TradeCancel
